module.exports = __webpack_public_path__ + "media/Island2946.eb8d0f86.mp4";